import React from 'react';

// Watermark logo HUT RI ke-80 - tampil di setiap hero halaman
const HutRiWatermark = ({ size = 'md' }) => {
  const sizes = { sm: 'w-[80px] md:w-[110px]', md: 'w-[110px] md:w-[140px] lg:w-[160px]', lg: 'w-[130px] md:w-[170px] lg:w-[200px]' };
  return (
    <div className="absolute top-4 right-4 md:top-6 md:right-10 z-10 pointer-events-none">
      <img
        src="/assets/hut-ri-81.png"
        alt="HUT RI ke-80 - Indonesia Berdaulat Adil dan Makmur"
        className={`${sizes[size]} h-auto`}
        style={{ filter: 'drop-shadow(0 4px 10px rgba(0,0,0,0.5))' }}
      />
    </div>
  );
};

export default HutRiWatermark;
